export const HeaderTitleArray = [
    {
        title: "Electricity",
        link: "https://enroll.bkvenergy.com/",
    },
    {
        title: "Earn & save",
        link: "https://bkvenergy.com/premier-benefits/",
    },
    {
        title: "Referrals",
        link: "https://bkvenergy.com/referral-program/",
    },
    {
        title: "Resources",
        link: "https://bkvenergy.com/blog/",
    },
    {
        title: "Support",
        link: "https://bkvenergy.com/support/",
    },
    {
        title: "Login",
        link: "https://account.bkvenergy.com/customerportal/myeaccount/login?connectName=BKV",
    },
];


export const ElectricObject = {
    "Plans": [
        {

            title: 'Bluebonnet Plan',
            link: 'https://bkvenergy.com/bluebonnet-plan/',
        },
        {

            title: '100% Renewable',
            link: 'https://bkvenergy.com/renewable-electricity-plans/',
        }, {

            title: 'FOR HOMES',
            link: 'https://bkvenergy.com/homeowner-electricity-plans/',
        }, {

            title: 'FOR APARTMENTS',
            link: 'https://bkvenergy.com/apartment-electricity-plans/',
        }
    ],
    "Service Areas": [
        {
            title: 'DALLAS',
            link: 'https://bkvenergy.com/dallas-electricity-plans/'
        },
        {
            title: 'HOUSTON',
            link: 'https://bkvenergy.com/houston-electricity-plans/',
        }, {
            title: 'CORPUS',
            link: 'https://bkvenergy.com/corpus-christi-electricity-plans/'
        }, {
            title: 'LUBBOCK',
            link: 'https://bkvenergy.com/lubbock-electricity-plans/'
        }
    ],
    "Other": [
        {
            title: 'FORT WORTH',
            link: 'https://bkvenergy.com/fort-worth-electricity-plans/'
        },
        {
            title: 'WACO',
            link: 'https://bkvenergy.com/waco-electricity-plans/'
        }, {
            title: 'ABILENE',
            link: 'https://bkvenergy.com/abilene-electricity-plans/'
        }, {
            title: 'VIEW ALL',
            link: 'https://bkvenergy.com/find-power/'
        }
    ]
}
export const EarnObject = {
    "Premier+ Benefits": [
        {
            title: 'ELECTROSHARE',
            link: 'https://bkvenergy.com/premier-benefits/electroshare-rewards/'
        }, {
            title: 'BLEND & EXTEND',
            link: 'https://bkvenergy.com/premier-benefits/blend-and-extend/'
        }, {
            title: 'SAVE NOW, PAY LATER',
            link: 'https://bkvenergy.com/premier-benefits/save-now-pay-later/'
        }, {
            title: 'SPARK ALERTS',
            link: 'https://bkvenergy.com/premier-benefits/spark-alerts/'
        }
    ],
    "Other": [
        {
            title: 'VOLTPOINTS LOYALTY',
            link: 'https://bkvenergy.com/premier-benefits/customer-loyalty-program/'
        }, {
            title: 'CONTRACT CONSULTATION',
            link: 'https://bkvenergy.com/premier-benefits/contract-consultation/'
        }, {
            title: '30-DAY POWER PILOT',
            link: 'https://bkvenergy.com/premier-benefits/30-day-power-pilot/'
        }, {
            title: 'BILL SCANNER',
            link: 'https://bkvenergy.com/bill-reader'
        }
    ],
    "Referral Program": [
        {
            title: 'HOW IT WORKS',
            link: 'https://bkvenergy.com/referral-program/#how'
        }, {
            title: 'REFERRAL TIPS',
            link: 'https://bkvenergy.com/referral-program/#tips'
        }, {
            title: 'START REFERRING',
            link: 'https://bkvenergy.com/referral-program/'
        }
    ]
}
export const ReferralsObject = {
    "Referral Program": [
        {
            title: 'HOW IT WORKS',
            link: 'https://bkvenergy.com/referral-program/#how'
        }, {
            title: 'REFERRAL TIPS',
            link: 'https://bkvenergy.com/referral-program/#tips'
        }, {
            title: 'START REFERRING',
            link: 'https://bkvenergy.com/referral-program/'
        }
    ]
}
export const ResourcesObject = {
    'Learning Center': [
        {
            title: 'THE ENERGY INDUSTRY',
            link: 'https://bkvenergy.com/learning-center-topic/how-the-energy-industry-works/'
        }, {
            title: 'ELECTRICTY GENERATION',
            link: 'https://bkvenergy.com/learning-center-topic/energy-production/'
        }, {
            title: 'TEXAS ENERGY MARKET',
            link: 'https://bkvenergy.com/learning-center-topic/deregulation-and-the-texas-market/'
        }, {
            title: 'SUSTAINABILITY',
            link: 'https://bkvenergy.com/learning-center-topic/sustainability-and-the-net-zero-initiative/'
        }
    ],
    "Blog": [
        {
            title: 'REDUCE YOUR ELECTRIC BILL',
            link: 'https://bkvenergy.com/blog/category/bills-and-savings/'
        }, {
            title: 'ENERGY NEWS',
            link: 'https://bkvenergy.com/blog/category/energy-news/'
        }, {
            title: 'ALL ABOUT TEXAS',
            link: 'https://bkvenergy.com/blog/category/texas/'
        }, {
            title: 'SAFETY GUIDES',
            link: 'https://bkvenergy.com/blog/category/safety/'
        }
    ],
    "Newsroom": [
        {
            title: 'BKVE IN THE NEWS',
            link: 'https://bkvenergy.com/in-the-news-category/media-coverage/'
        }, {
            title: 'PRESS RELEASES',
            link: 'https://bkvenergy.com/in-the-news-category/press-releases/'
        }, {
            title: 'MEDIA ASSETS',
            link: 'https://bkvenergy.com/media-assets/'
        }, {
            title: 'ABOUT US',
            link: 'https://bkvenergy.com/about-us/'
        }
    ]
}
export const SupportObject = {
    "Account Help": [
        {
            title: 'REGISTER YOUR ACCOUNT',
            link: 'https://bkvenergy.com/support/how-to-register-portal-account/'
        }, {
            title: 'AUTOPAY SETTINGS',
            link: 'https://bkvenergy.com/support/autopay/'
        }, {
            title: 'TRANSFER OF SERVICE',
            link: 'https://bkvenergy.com/transfer-of-service/'
        }
    ],
    "Support Center": [
        {
            title: 'BILLING & PAYMENTS',
            link: 'https://bkvenergy.com/support-category/billing-payments/'
        }, {
            title: 'ACCOUNT SETUP',
            link: 'https://bkvenergy.com/support-category/sign-up-accounts/'
        }, {
            title: 'ELECTRICITY SERVICES',
            link: 'https://bkvenergy.com/support-category/bkve-electricity-services/'
        }, {
            title: 'ENERGY SAVING TIPS',
            link: 'https://bkvenergy.com/blog/category/bills-and-savings/'
        }
    ],
    "Contact us": [
        {
            title: 'REPORT AN OUTAGE',
            link: 'https://bkvenergy.com/outage/'
        }, {
            title: 'CHAT WITH AN AGENT',
            link: 'https://bkvenergy.com/contact-us/'
        }
    ]
}

export const getHeaderLink = (val) => {
    if (val === "Plans") return "https://enroll.bkvenergy.com/";
    if (val === "Service Areas") return "https://bkvenergy.com/find-power/";
    if (val === "Premier+ Benefits")
        return "https://bkvenergy.com/premier-benefits/";
    if (val === "Referral Program")
        return "https://bkvenergy.com/referral-program/";
    if (val === "Learning Center")
        return "https://bkvenergy.com/learning-center/";
    if (val === "Blog") return "https://bkvenergy.com/blog/";
    if (val === "Newsroom") return "https://bkvenergy.com/newsroom/";
    if (val === "Account Help" || "Support Center")
        return "https://bkvenergy.com/support/";
    if (val === "Contact us") return "https://bkvenergy.com/contact-us/";
};